import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ConfirmationModal, Typography } from 'seagull';
import { routes } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import ExternalLinkButton from './ExternalLinkButton';
export default function TerminateServiceModal(props) {
    const { serviceName, agreementId, stoppageMayAffectNextBill, canPauseService, onKeepService, onStopService } = props;
    const { t: commonTexts } = useLocaleKeys('common');
    const { t: texts } = useLocaleKeys('components.terminateServiceModal');
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'terminate_service_confirm'
            },
            secondaryButton: {
                name: 'terminate_service_cancel'
            }
        },
        title: texts.title({
            serviceName
        }),
        skin: "danger",
        testId: "terminate-service-modal",
        content: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: texts.areYouSure()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: texts.clientNoLongerCharged()
                }),
                stoppageMayAffectNextBill && /*#__PURE__*/ _jsx(Typography, {
                    children: texts.removedFromNextBill()
                }),
                canPauseService && /*#__PURE__*/ _jsxs(Typography, {
                    style: {
                        marginBlockStart: 20
                    },
                    children: [
                        texts.pauseNote(),
                        /*#__PURE__*/ _jsx(ExternalLinkButton, {
                            openInNewTab: true,
                            href: routes.billingHub(agreementId),
                            bi: {
                                name: 'terminate_service_billing_hub'
                            },
                            children: texts.billingHub()
                        }),
                        texts.pauseNoteSuffix()
                    ]
                })
            ]
        }),
        primaryButtonLabel: commonTexts.buttons.stopService(),
        onPrimaryButtonClick: ()=>onKeepService(),
        secondaryButtonLabel: commonTexts.buttons.keepService(),
        onSecondaryButtonClick: ()=>onStopService(),
        onCloseButtonClick: ()=>onStopService()
    });
}
